import { render } from "./ChoicesCombinationsInput.vue?vue&type=template&id=3b9622de&scoped=true"
import script from "./ChoicesCombinationsInput.vue?vue&type=script&lang=js"
export * from "./ChoicesCombinationsInput.vue?vue&type=script&lang=js"

import "./ChoicesCombinationsInput.vue?vue&type=style&index=0&id=3b9622de&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9622de"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QField,QIcon});
